module.exports = __webpack_public_path__ + "img/banner-01.905d9f7d.jpg";